/*eslint-disable*/
import api from '../'

class wordStructure {
    // POST: couples
    static getItemsByRequest (params) {
        return api.axios.get('/wordStructure/items', { params }).then(response => response.data.items);
    }
}

export default wordStructure;
